module.exports = __webpack_public_path__ + "SC01.5ebcfab2.png";